export { ButtonCheckboxDirective } from './button-checkbox.directive';
export { ButtonRadioDirective } from './button-radio.directive';
export { ButtonsModule } from './buttons.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-bootstrap/buttons/index.js
// module id = 551
// module chunks = 0